import React from 'react';
import { CTAButton } from './CTAButton';
import { MockupImage } from './MockupImage';
import { TrustLine } from './TrustLine';
import { CHECKOUT_URL, PRODUCT, PRODUCT_TAGLINE } from '../data/constants';
const INCLUDED = ['6 professional private pilot visual modules', '5 strategic aviation study bonuses', 'Aircraft systems and component diagrams', 'Cockpit instrument identification references', 'Aerodynamics and flight maneuver illustrations', 'VFR navigation and airspace visual guides', 'Aviation weather and flight planning resources', 'Flight procedure and decision-making scenarios'];
export function Offer() {
  return <section id="offer" className="scroll-mt-2 bg-white py-5 sm:py-7" data-id="element-120" data-mp="13yc9xpenils4">
      <div className="mx-auto max-w-5xl px-4 sm:px-6" data-id="element-121" data-mp="ywwqu2w1apcd">
        <p className="mx-auto w-fit rounded-md bg-gold px-3 py-1 font-display text-xs font-extrabold uppercase tracking-widest text-navy sm:text-sm" data-id="element-122" data-mp="2fc698up91el5">
          SPECIAL LAUNCH OFFER
        </p>

        <div className="mt-2 overflow-hidden rounded-2xl border-[3px] border-dashed border-aviation bg-white shadow-lg" data-id="element-123" data-mp="pk7gbmti0n9z">
          <div className="bg-navy p-3 text-center sm:p-5" data-id="element-124" data-mp="uisfrk0xf2xd">
            <h2 className="text-2xl leading-none text-white sm:text-4xl" data-id="element-125" data-mp="ulem5gc2zce0">✈️ {PRODUCT}</h2>
            <p className="mx-auto mt-1 max-w-2xl font-display text-xs font-semibold uppercase leading-tight tracking-wide text-gold sm:text-base" data-id="element-126" data-mp="zj6ci5x2uqg3">
              {PRODUCT_TAGLINE}
            </p>
          </div>

          <div className="grid gap-3 p-3 sm:p-6 lg:grid-cols-[0.9fr_1.1fr] lg:items-center lg:gap-6" data-id="element-127" data-mp="6rmswkwkjadk">
            <MockupImage data-id="element-128" data-mp="bqg426odupak" />

            <div data-id="element-129" data-mp="ftvzx0smolm7">
              <p className="font-display text-lg font-extrabold uppercase text-navy sm:text-xl" data-id="element-130" data-mp="ftctag8fhjnh">
                Complete 6-in-1 Professional Aviation Visual System
              </p>
              <ul className="mt-1 grid gap-1" data-id="element-131" data-mp="3k95m0jtrt7kt">
                {INCLUDED.map(item => <li key={item} className="flex items-start gap-2" data-id="element-132" data-mp="3o9z4uyscvw6u">
                    <span className="leading-snug" aria-hidden="true" data-id="element-133" data-mp="3o84o7wo4aq8k">
                      ✅
                    </span>
                    <span className="text-sm font-medium leading-snug text-graphite sm:text-base" data-id="element-134" data-mp="qgxh8309b9ov">
                      {item}
                    </span>
                  </li>)}
              </ul>

              <div className="mt-3 rounded-xl border-2 border-gold bg-gold-soft px-3 py-2 text-center" data-id="element-135" data-mp="105xla0tm8v9x">
                <p className="font-display text-sm font-extrabold uppercase leading-tight text-navy sm:text-lg" data-id="element-136" data-mp="cg381i5dx4p5">
                  🔥 GET {PRODUCT} TODAY —{' '}
                  <span className="whitespace-nowrap text-3xl text-aviation sm:text-4xl" data-id="element-137" data-mp="7k4pib6qmgwn">$27 USD</span>
                </p>
              </div>

              <div className="mt-3 flex flex-col items-center" data-id="element-138" data-mp="hfpt2drgfp8i">
                <CTAButton href={CHECKOUT_URL} data-id="element-139" data-mp="1wwpymqp60980">✈️ GET INSTANT ACCESS</CTAButton>
                <TrustLine items={['Immediate Digital Access', '🛡️ 7-Day Money-Back Guarantee']} data-id="element-140" data-mp="1wyszy6vrpos1" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}